import React from 'react';

import { IIconProps, TIconType } from '../interface';

const LinkIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			data-testid='link-icon'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M8.82187 15.1781L15.1781 8.8125'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.5937 16.7719L10.9406 19.425C10.5226 19.843 10.0264 20.1745 9.48032 20.4007C8.93422 20.6269 8.3489 20.7434 7.7578 20.7434C6.56401 20.7434 5.41912 20.2691 4.57499 19.425C3.73085 18.5809 3.25662 17.436 3.25662 16.2422C3.25662 15.0484 3.73085 13.9035 4.57499 13.0594L7.22811 10.4062'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.7719 13.5937L19.425 10.9406C20.2691 10.0965 20.7434 8.95159 20.7434 7.7578C20.7434 6.56401 20.2691 5.41912 19.425 4.57499C18.5809 3.73085 17.436 3.25662 16.2422 3.25662C15.0484 3.25662 13.9035 3.73085 13.0594 4.57499L10.4062 7.22811'
				stroke={props?.color || '#2E2E6B'}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default LinkIcon;
